export default "__VITE_ASSET__f46a3bdf__"